import { Spin, Button, Modal } from 'antd';
import { useLocation } from 'react-router-dom';
import { CheckOutlined, CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import qs from 'query-string';
import { useRequest } from 'ahooks';
import { getInsuranceFinancingDetail } from '@/services/supplyChainFinance';
import { updateEnd } from '@/services/myApplication';
import './index.less';

const obj = {
  0: 'processing', 1: 'error', 2: 'cancel', 3: 'success', // status 为0正常状态，进行中UI为实心数字； 1 拒绝； 2取消； 3：所有流程完成
};

export default function SupplyChainFinanceTimeline() {
  const { search } = useLocation();
  const { id } = qs.parse(search);
  const { data = {}, loading, run } = useRequest(() => getInsuranceFinancingDetail(id));
  const { run: updateRun } = useRequest(updateEnd, {
    manual: true,
    onSuccess() {
      run();
    },
  });

  function getIcon(status, index) {
    if (status === 0) {
      return index;
    } if (status === 1 || status === 2) {
      return <CloseOutlined />;
    }
    return <CheckOutlined />;
  }

  function confirm() {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: '确认完结当前申请吗？',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        updateRun(id);
      },
    });
  }

  return (
    <Spin spinning={loading}>
      <div>
        <div className="myapplication-detail__title">进度查询</div>
        <div className="myapplication-detail__sub-title">保险需求</div>
        <div className="myapplication-detail__grid">
          <div>
            所属产业链：
            {data?.industryChainBelongs || '-'}
          </div>
          <div>
            项目名称：
            {data?.projectName || '-'}
          </div>
          <div>
            申请保险机构：
            {data?.orgName || '-'}
          </div>
          <div>
            产品名称：
            {data?.productName || '-'}
          </div>
        </div>
        <div className="myapplication-detail__sub-title">保险产品信息</div>
        <div className="myapplication-detail__grid">
          <div>
            产品名称：
            {data?.loanProductsVo?.productName || '-'}
          </div>
          <div>
            保险机构：
            {data?.loanProductsVo?.name || '-'}
          </div>
          <div>
            保险类型：
            {data?.loanProductsVo?.orgType || '-'}
          </div>
          <div>
            单位保险金额：
            {data?.loanProductsVo?.orgAmount || '-'}
          </div>
          <div>
            保险费率：
            {data?.loanProductsVo?.orgRate || '-'}
          </div>
          <div>
            联系方式：
            {data?.loanProductsVo?.orgTel || '-'}
          </div>
          <div style={{ gridColumn: '1 / -1', display: 'flex' }}>
            <span style={{ flexShrink: 0 }}>产品介绍：</span>
            <div dangerouslySetInnerHTML={{ __html: data?.loanProductsVo?.content }} />
          </div>
          <div style={{ gridColumn: '1 / -1', display: 'flex' }}>
            <span style={{ flexShrink: 0 }}>保险责任：</span>
            <div dangerouslySetInnerHTML={{ __html: data?.loanProductsVo?.content1 }} />
          </div>
          <div style={{ gridColumn: '1 / -1', display: 'flex' }}>
            <span style={{ flexShrink: 0 }}>投保条件：</span>
            <div dangerouslySetInnerHTML={{ __html: data?.loanProductsVo?.content2 }} />
          </div>
          <div style={{ gridColumn: '1 / -1', display: 'flex' }}>
            <span style={{ flexShrink: 0 }}>理赔流程：</span>
            <div dangerouslySetInnerHTML={{ __html: data?.loanProductsVo?.content3 }} />
          </div>
          <div style={{ gridColumn: '1 / -1', display: 'flex' }}>
            <span style={{ flexShrink: 0 }}>其他：</span>
            <div dangerouslySetInnerHTML={{ __html: data?.loanProductsVo?.content4 }} />
          </div>
        </div>
        <div className="myapplication-detail__sub-title">进度信息</div>
        <div className="supply-chain-finance-timeline">
          {
            data?.item?.map((item, index) => (
              <div className={`timeline-item timeline-item-${index + 1 === data?.item.length && obj?.[item.status]}`}>
                <div className="timeline-icon">
                  {
                    index + 1 === data?.item.length
                      ? (
                        <>
                          {getIcon(item.status, index + 1)}
                        </>
                      ) : <CheckOutlined />
                  }
                </div>
                <div className="timeline-cont">
                  <div className="timeline-title">{item.title}</div>
                  <div>{item.operateReason}</div>
                  <div>{item.time}</div>
                </div>

              </div>
            ))
          }
        </div>
        {
          data?.finish && (
            <div className="supply-chain-finance__btn-box">
              <Button type="primary" onClick={confirm}>完结</Button>
            </div>
          )
        }
      </div>
    </Spin>
  );
}
